import BaseRepository from '@/api/repositories/BaseRepository';

export default class VehicleRepository extends BaseRepository {
	getVehicleAllKilometrage(vehicleId, options = {}) {
		return this.get('kilometrage/:vehicleId', {
			vehicleId: vehicleId,
			...options,
		});
	}

	getManufacturerNames(searchValue) {
		return this.post('manufacturernames', {
			searchValue: searchValue || undefined,
		});
	}

	getModelNames(searchValue, name) {
		return this.post('modelnames', {
			searchValue: searchValue,
			manufacturer: name,
		});
	}

	get endpoint() {
		return 'api/vehicles';
	}

	updateVehicleRegistrationImage(vehicleId, vehicleRegistrationImage) {
		return this.put(`${vehicleId}/vehicleRegistrationImage`, {}, { vehicleRegistrationImage });
	}

	updateVehicleVinImage(vehicleId, vinImage) {
		return this.put(`${vehicleId}/vehicleVinImage`, {}, { vinImage });
	}
}
